export default __webpack_public_path__ + "static/media/EDL.89a893b1.webp";